import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, } from "react";
import { useSelector } from "react-redux";
import { featureSelectionInfoStickyHeaderSelector } from "../../store/selectors";
import FeatureDetailsContent from "../feature-details-content";
import CloseButton from "./close-button";
import Header from "./header";
import WithStickyHeader from "./with-sticky-header";
import WithoutStickyHeader from "./without-sticky-header";
import Wrapper from "./wrapper";
export default function FeatureSelectionInfo({ feature, enableKeyboardControl, }) {
    const hasStickyHeader = useSelector(featureSelectionInfoStickyHeaderSelector);
    const renderWrapper = useCallback((attrs, ref) => (_jsx(Wrapper, Object.assign({ ref: ref, feature: feature, enableKeyboardControl: enableKeyboardControl }, attrs))), [enableKeyboardControl, feature]);
    if (!feature) {
        return null;
    }
    const T = hasStickyHeader ? WithStickyHeader : WithoutStickyHeader;
    return (_jsx(T, { feature: feature, close: _jsx(CloseButton, { feature: feature, enableKeyboardControl: enableKeyboardControl }), header: _jsx(Header, { feature: feature }), content: _jsx("div", { className: "ms3-feature-selection-info__content", children: _jsx(FeatureDetailsContent, { feature: feature }) }), renderWrapper: renderWrapper }));
}
